import { createTheme } from '@mui/material/styles';

import baseConfigTheme from './base-config-theme';

// eslint-disable-next-line max-len
const baseGreenTheme = createTheme({
  palette: {
    primary: {
      light: '#4FB087',
      main: '#429672',
      dark: '#34785B',
    },
    primaryLight: {
      light: '#F1FDF3',
      main: '#ECF8EE',
      dark: '#D9F1DD',
    },
    dangerLight: {
      dark: '#E9BDC1',
      main: '#F4D3D6',
      light: '#F5EDEE',
    },
    warningLight: {
      main: '#F8F2E1',
      dark: '#ECE1C2',
    },
    successLight: {
      dark: '#D9F1DD',
      main: '#ECF8EE',
      light: '#F5FBF7',
    },
    textLight: {
      main: '#627178',
    },
    secondary: {
      light: '#3D6B53',
      main: '#2D5540',
      dark: '#234435',
    },
    danger: {
      light: '#D44E5C',
      main: '#DA6974',
      dark: '#B81F2A',
    },
    warning: {
      light: '#D4B04E',
      main: '#DABC69',
      dark: '#B49642',
    },
    info: {
      light: '#69C3DA',
      main: '#4EB9D4',
      dark: '#429DB4',
    },
    success: {
      light: '#61C471',
      main: '#45BA58',
      dark: '#3B9E4B',
    },
    text: {
      secondary: '#627178',
      disabled: '#7F8D93',
    },
    background: {
      default: '#F4FBF6',
      paper: '#FFF',
    },
    divider: '#E7EBEF',
    gray: {
      dark: '#E7E0DA',
      main: '#E1EFE4',
      light: '#EDF0F3',
    },
    grayLight: {
      main: '#f2f4fb',
    },
    purple: {
      main: '#864ED4',
    },
    orange: {
      main: '#D4894E',
    },
    lime: {
      main: '#95BD40',
    },
    pink: {
      main: '#BD40A1',
    },
  },
  ...(baseConfigTheme as any),
});

// Reference resolved palette so we don't duplicate hex values
const { palette } = baseGreenTheme;

// Override base-config blue-specific component styles for green theme
const outherTheme = createTheme(baseGreenTheme, {
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: palette.primary.dark,
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            background: (palette as any).primaryLight.dark,
            borderColor: (palette as any).primaryLight.dark,
            color: palette.primary.dark,
            '&:hover': {
              background: (palette as any).primaryLight.dark,
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: palette.primary.light,
          color: '#fff',
          '&:hover': {
            backgroundColor: palette.primary.main,
          },
          '&:active': {
            backgroundColor: palette.primary.dark,
          },
          '&.Mui-disabled': {
            backgroundColor: (palette as any).primaryLight.dark,
            color: '#fff',
            opacity: 0.6,
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
              '& + .MuiSwitch-track': {
                backgroundColor: palette.primary.main,
              },
            },
          },
        },
      },
    },
  },
});

export default outherTheme;
